module.exports = __webpack_public_path__ + "b113b65c0932c5d41faa62de995e4244.png";